import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { RoleAdminSuReactivateStaffRequest } from "../shared/RoleAdminSuReactivateStaffRequest";
import { RoleAdminSuReactivateStaffOptionsComponent } from "./role-admin-su-reactivate-staff-options/role-admin-su-reactivate-staff-options.component";

@Component({
	selector: "caass-role-su-user-inactive-staff",
	templateUrl: "./role-su-user-inactive-staff.component.html",
	styleUrls: ["./role-su-user-inactive-staff.component.css"],
})
export class RoleSuUserInactiveStaffComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadUsers();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	userpagerows: any = 10;
	userpagefirst: any = 0;

	SelectedUsers: any = [];
	lstUsers: any = [];

	lstPersonTypeDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];

	UserCols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		{ field: "SchoolFullName", header: "Home School" },
		// { field: "UserLevelDesc", header: "User Level" },
		// { field: "ActiveDesc", header: "Active" },
	];

	LoadingUser: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////

	loadUsers() {
		this.errorMessage = "";

		this.lstUsers = [];
		this.SelectedUsers = [];
		this.LoadingUser = true;

		var result = this.dataService.RoleAdminSuUserAssignedInactiveStaffSelect();
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonTypeDesc)));
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.ActiveDesc)));
				this.lstDefinedByDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.DefinedByDesc)));

				this.LoadingUser = false;
			},
			(error) => {
				this.LoadingUser = false;
			}
		);
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////

	onUserRefresh() {
		this.loadUsers();
	}

	onStaffActivate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select users to activate";
			return;
		}

		//
		// Confirm + Options
		//
		var ref = this.dialogService.open(RoleAdminSuReactivateStaffOptionsComponent, {
			header: "Confirm Reactivate Staff",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstSelectedUsers: this.SelectedUsers,
			},
		});
		ref.onClose.subscribe((response: any) => {
			if (response.ChangeDefinedBy != undefined) {
				this.onFinishStaffActivate(response.ChangeDefinedBy, response.UnlockAccounts);
			}
		});
	}

	onFinishStaffActivate(ChangeDefinedBy, UnlockAccounts) {
		this.Processing = true;

		var lstUID = this.SelectedUsers.map((item) => item.UserID);

		var lstLocked = this.SelectedUsers.filter((item) => item.Locked == true);
		var lstLUID = lstLocked.map((item) => item.UserID);

		var parms: RoleAdminSuReactivateStaffRequest = {
			ChangeDefinedBy: ChangeDefinedBy == true ? 1 : 0,
			UnlockAccounts: UnlockAccounts == true ? 1 : 0,
			lstUserID: lstUID,
			lstLockedUserID: lstLUID,
		};

		var result = this.dataService.RoleAdminSuReactivateStaff(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "inactivestaff",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Staff were reactivated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "inactivestaff",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not reactivate users: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"User Level",`;
		DataStr += `"User Active",`;
		DataStr += `"Person Defined By",`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUsers.length; z++) {
			var next = this.lstUsers[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.UserLevelDesc + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += `"` + next.DefinedByDesc + `"`;

			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "UsersAssignedToInactiveStaff";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////

	onUserRowSelect(val) {
		this.errorMessage = "";
	}

	onUserRowUnselect(val) {
		this.errorMessage = "";
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingUser == true || this.Processing == true;
	}
	////////////////////////////////////////////////
}
